import api from "./axiosInstance";

export function login(numisId, password) {
  return api.post(
    "/auth/login",
    { numistrail_id: numisId, password },
    { skipAuth: true }
  );
}

export function requestPasswordReset(identifier) {
  return api.post(
    "/auth/forgot-password",
    { identifier },
    { skipAuth: true }
  );
}

export function resetPassword(token, password) {
  return api.post(
    "/auth/reset-password",
    { token, password },
    { skipAuth: true }
  );
}
